import { IconButton, LinearProgress, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import AnomalyIco from "../../assets/icons/AnomalyIco";
import NotificationCloseIco from "../../assets/icons/NotificationCloseIco";
import CommonButton from "../../component/Button";
import { CommonGrid2, DotColor } from "../common-components/StyledComponents";
import { CustomizeSpan } from "../jobs/style";
import { CustomDiv } from "../chat-bot/style";
import { statusOptions } from "../common-components/NotificationFunction";
import PlayIco from "../../assets/icons/PlayIco";

const NotificationCard = ({
  isInProgress,
  data,
  buffer_shown,
  handleRemove = () => {},
  wrapRefs,
  cardRefs,
  name_pass,
  handleActionClick = () => {},
  notification,
  removeIcon = true,
}) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <CommonGrid2 container spacing={1.5} size={12}>
      {data.map((item, index) => {
        // if (notification.condition_id.includes(item.id || item.jobId)) {
        //   return null;
        // }
        return (
          <CommonGrid2
            size={12}
            key={index}
            // ref={(el) => {
            //   if (wrapRefs && el) {
            //     wrapRefs[index] = el;
            //   }
            // }}
            // sx={{ position: "relative", overflow: "visible" }}
          >
            <CommonGrid2
              // ref={(el) => {
              //   if (cardRefs && el) {
              //     cardRefs[index] = el;
              //   }
              // }}
              borderRadius={"10px"}
              border={"1px solid #EAECF0"}
              padding={"10px"}
              flexDirection={"column"}
              // sx={{ position: "relative", transition: "opacity 0.1s" }}
            >
              <CommonGrid2 display="flex" alignItems="flex-start" gap={"8px"}>
                {item.icon && (
                  <CommonGrid2 display="flex" justifyContent="flex-start">
                    {item.icon}
                  </CommonGrid2>
                )}

                <CommonGrid2 flex={1}>
                  <CommonGrid2
                    display={"flex"}
                    alignItems={"flex-start"}
                    justifyContent={"space-between"}
                    flexWrap={"wrap"}
                    marginTop={"-3px"}
                  >
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#101828"
                      sx={{ mb: 0.25, wordBreak: "break-word", flex: 1 }}
                      textTransform={"capitalize"}
                    >
                      {item.title}
                    </Typography>

                    {removeIcon && (
                      <IconButton
                        onClick={() => handleRemove(index, item, name_pass)}
                        sx={{
                          padding: "6px",
                          position: "relative",
                          right: "-8px",
                          top: "-4px",
                          "&:hover": { background: "#FEE4E2" },
                        }}
                      >
                        <NotificationCloseIco />
                      </IconButton>
                    )}
                  </CommonGrid2>

                  {item.job_title && (
                    <CommonGrid2
                      display={"flex"}
                      alignItems={"center"}
                      gap={"5px"}
                    >
                      <Typography variant="subtitle2" fontWeight={700}>
                        {item.job_title}
                      </Typography>
                      {item.meta && (
                        <CommonGrid2
                          display={"flex"}
                          border={"1px solid #EAECF0"}
                          padding={"0px 6px 0px 3px"}
                          borderRadius={"50px"}
                          alignItems={"center"}
                          gap={"4px"}
                        >
                          <AnomalyIco color={"#17B26A"} size={"14"} />
                          <Typography variant="subtitle2" fontWeight={500}>
                            {item.meta}
                          </Typography>
                        </CommonGrid2>
                      )}
                      {item.unique_id && (
                        <Typography
                          variant="subtitle2"
                          color="#7F56D9"
                          fontWeight={700}
                        >
                          {" "}
                          - {item.unique_id}
                        </Typography>
                      )}
                    </CommonGrid2>
                  )}

                  {buffer_shown && (
                    <CommonGrid2 sx={{ mb: 0.5 }}>
                      {Array.isArray(item.resume) ? (
                        <Fragment>
                          {(expanded
                            ? item.resume
                            : item.resume.slice(0, 1)
                          ).map((item, index) => (
                            <Fragment key={index}>
                              <Typography
                                fontWeight={500}
                                variant="caption"
                                color="#667085"
                                sx={{
                                  display: "block",
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                  whiteSpace: "normal",
                                }}
                              >
                                {item.resume || item.file_name}
                                {item.percent === 100 && (
                                  <CustomizeSpan
                                    position="relative"
                                    top="2px"
                                    left="5px"
                                  >
                                    <AnomalyIco color={"#17B26A"} size={"14"} />
                                  </CustomizeSpan>
                                )}
                              </Typography>
                              {item.percent !== 100 && (
                                <CommonGrid2 marginTop={0.5} marginBottom={1}>
                                  <LinearProgress
                                    variant="determinate"
                                    value={item.percent}
                                    sx={{
                                      height: 6,
                                      borderRadius: 999,
                                      backgroundColor: "#F2F4F7",
                                      "& .MuiLinearProgress-bar": {
                                        backgroundColor: "#7F56D9",
                                      },
                                    }}
                                  />
                                  <CommonGrid2
                                    display={"flex"}
                                    justifyContent={"space-between"}
                                    alignItems={"center"}
                                    marginTop={"0.5rem"}
                                  >
                                    <Typography
                                      variant="caption"
                                      color="#667085"
                                      // textTransform={"capitalize"}
                                    >
                                      {item.percent === 100
                                        ? "Completed"
                                        : // : "In "+item.status+"..."}
                                          "In Progress.."}
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      color="#101828"
                                      fontWeight={600}
                                    >
                                      {item.percent}%
                                    </Typography>
                                  </CommonGrid2>
                                </CommonGrid2>
                              )}
                            </Fragment>
                          ))}
                          {item.resume.length > 1 && (
                            <Typography
                              variant="caption"
                              marginTop={0.3}
                              color="#6941C6"
                              sx={{ cursor: "pointer" }}
                              onClick={() => setExpanded(!expanded)}
                            >
                              {expanded ? "Show less" : "Show more"}
                            </Typography>
                          )}
                        </Fragment>
                      ) : (
                        <CommonGrid2 marginTop={0.5} marginBottom={1}>
                          <Typography
                            variant="caption"
                            color="#667085"
                            fontWeight={600}
                            width={"100%"}
                            sx={{
                              display: "block",
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                  whiteSpace: "normal",
                            }}
                          >
                            {item.resume || item.file_name || "JEM Creating..."}
                          </Typography>
                          <LinearProgress
                            variant="determinate"
                            value={item.percent}
                            sx={{
                              height: 6,
                              borderRadius: 999,
                              backgroundColor: "#F2F4F7",
                              "& .MuiLinearProgress-bar": {
                                backgroundColor: "#7F56D9",
                              },
                            }}
                          />
                          <CommonGrid2
                            display={"flex"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            marginTop={"0.2rem"}
                          >
                            <Typography
                              variant="caption"
                              color="#667085"
                              display="block"
                              width="80%"
                              sx={{
                                wordBreak: "break-word",
                                whiteSpace: "normal",
                                lineHeight: 1.4,
                              }}
                            >
                              {item.percent === 100
                                ? "Completed"
                                : item.metamessage}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="#101828"
                              fontWeight={600}
                            >
                              {item.percent}%
                            </Typography>
                          </CommonGrid2>
                        </CommonGrid2>
                      )}
                    </CommonGrid2>
                  )}

                  {item.metadata && (
                    <Fragment>
                      <CommonGrid2
                        display={"flex"}
                        alignItems={"center"}
                        gap={"5px"}
                        marginTop={"2px"}
                      >
                        <Typography variant="subtitle2" fontWeight={700}>
                          {item.metadata.job_title ||
                            item?.metadata?.resume_title ||
                            item?.metadata?.message}
                          {(item.metadata.job_order_no ||
                            item.metadata.order_no) && (
                            <CustomizeSpan color="#7F56D9" fontWeight={700}>
                              {" "}
                              -{" "}
                              {item.metadata.job_order_no ||
                                item.metadata.order_no}
                            </CustomizeSpan>
                          )}
                          {(item.metadata.company_name ||
                            (item.sub_type !== "candidate_availability_update" &&
                            item.metadata.candidate_name)) && (
                            <CustomizeSpan fontWeight={700}>
                              {item.metadata.job_order_no ||
                              item.metadata.order_no ||
                              item.metadata.job_id
                                ? ` - ${
                                    item.metadata.company_name ||
                                    item.metadata.candidate_name
                                  }`
                                : item.metadata.company_name
                                ? ` - ${item.metadata.company_name}`
                                : item.metadata.candidate_name}
                            </CustomizeSpan>
                          )}
                        </Typography>
                      </CommonGrid2>
                      {/* {item.metadata.email && (
                        <Fragment>
                          <Typography variant="subtitle2" fontWeight={600}>
                            Email : {item.metadata.email}
                          </Typography>
                          <Typography variant="subtitle2" fontWeight={600}>
                            Remaining Uploads: {item.metadata.remaining_uploads}
                          </Typography>
                          <Typography variant="subtitle2" fontWeight={600}>
                            Resume Count: {item.metadata.resume_count}
                          </Typography>
                        </Fragment>
                      )} */}
                      {item.sub_type === "candidate_availability_update" && (
                        <Fragment>
                          <Typography variant="subtitle2" fontWeight={600}>
                            Name : {item.metadata.candidate_name}
                          </Typography>
                          <CommonGrid2
                            display={"flex"}
                            alignItems={"center"}
                            gap={"5px"}
                          >
                            <Typography variant="subtitle2" fontWeight={600}>
                              Status:
                            </Typography>
                            <CommonGrid2
                              display="flex"
                              alignItems="center"
                              borderRadius="5px"
                              padding="0px 5px"
                              gap="5px"
                              width={"max-content"}
                              boxShadow="0px 0px 1px 0px #101828"
                              fontSize="12px"
                              border={
                                statusOptions[item?.metadata?.status]?.border
                              }
                            >
                              <DotColor
                                color={
                                  statusOptions[item?.metadata?.status]?.color
                                }
                              />
                              {item.metadata.status}
                            </CommonGrid2>
                          </CommonGrid2>
                          <Typography variant="subtitle2" fontWeight={600}>
                            Availability: {item.metadata.availability}
                          </Typography>
                        </Fragment>
                      )}
                      {/* {item.sub_type === "coversheet_submitted" && (
                        <Typography variant="subtitle2" fontWeight={700}>
                          {"Coversheet submitted successfully."}
                        </Typography>
                      )} */}
                      {item.metadata.current_stage && (
                        <Typography variant="subtitle2" fontWeight={600}>
                          Current Stage : {item.metadata.current_stage}
                        </Typography>
                      )}
                      {item.metadata.next_stage && (
                        <Typography variant="subtitle2" fontWeight={600}>
                          Next Stage : {item.metadata.next_stage}
                        </Typography>
                      )}
                      {item.metadata.current_stage && (
                        <CommonGrid2
                          display={"flex"}
                          gap={"5px"}
                          alignItems="center"
                        >
                          <PlayIco />
                          <Typography variant="subtitle2" fontWeight={600}>
                            In Automation
                          </Typography>
                        </CommonGrid2>
                      )}
                    </Fragment>
                  )}

                  {item.failed && (
                    <CustomDiv>
                      <Typography
                        variant="subtitle2"
                        color="#D80027"
                        fontWeight={600}
                      >
                        #Resume format Error!
                      </Typography>
                      <Typography
                        variant="caption"
                        fontWeight={700}
                        color={"#D80027"}
                      >
                        Error :{" "}
                        <CustomizeSpan lineHeight="1rem">
                          {item.metadata?.error}
                        </CustomizeSpan>
                      </Typography>
                    </CustomDiv>
                  )}

                  <CommonGrid2
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    marginTop={0.5}
                  >
                    {item.time && (
                      <Typography
                        variant="caption"
                        fontWeight={500}
                        color={isInProgress ? "#7F56D9" : "#667085"}
                      >
                        {item.time}
                      </Typography>
                    )}
                    {item.failed ? null : item.action ? (
                      <CommonButton
                        value={item.action}
                        variant="outlined"
                        onClick={() => handleActionClick(name_pass, item)}
                        color="#6941C6"
                        fontSize={"13px"}
                        background={"transparent"}
                        fontWeight={700}
                        padding={"2px 5px"}
                        borderRadius={"5px"}
                        customStyle={{
                          border: "none",
                          "&:hover": { background: "transparent" },
                        }}
                      />
                    ) : null}
                  </CommonGrid2>
                </CommonGrid2>
              </CommonGrid2>
            </CommonGrid2>
          </CommonGrid2>
        );
      })}
    </CommonGrid2>
  );
};

export default NotificationCard;
